export default __webpack_public_path__ + "static/media/puff-geosecma-mina_sidor_2297aed2c0f9f7cb3711e27e95f1e5ed.d6d36fc2.png";